<template>


<div class="page-content">          
        <div data-height="130" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="130" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="130" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
        
        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Recepción Ordenes de trabajo</h1>
            <a href="#" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"></a>
        </div>
        
        <div class="content-boxed shadow-small">
            <div class="content bottom-0">
                <p class="bottom-20">
                    Seleccione la reserva para continuar
                </p>
            </div>
        </div>
        
        <div class="content">
         
 <div id="app">
    <div class="container">

            <div class="row">
          <div class="col-3 mt-2">
            <button class="btn btn-outline-secondary" @click="undoimage">Undo image</button>
            <button class="btn btn-outline-secondary" @click="undo">Undo</button>
          </div>
          <div class="col-3 mt-2">
            <button class="btn btn-outline-primary" @click="save">Save</button>
          </div>
          <div class="col-3 mt-2">
            <button class="btn btn-outline-primary" @click="change">Change</button>
          </div>
          <div class="col-3 mt-2">
            <button class="btn btn-outline-primary" @click="resume">Resume</button>
          </div>
          <div class="col-3 mt-2">
            <button class="btn btn-outline-primary" @click="eraser">Eraser</button>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 mt-2">
            <VueSignaturePad
              id="signature"
              width="700px"
              height="450px"
              ref="signaturePad"
            />
          </div>
        </div>
    
      </div>
    </div>
    
    

          </div>

-----------------------------------------
<div>
  ssss
</div>



  </div>


</template>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/imagenfondoservicio.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:700px;
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>

<script>
//  background-image: url(https://preview.ibb.co/jnW4Qz/Grumpy_Cat_920x584.jpg), 
  import * as db from "./../../database.js";
  import Vue from 'vue';
  import VueSignaturePad from 'vue-signature-pad';

  Vue.use(VueSignaturePad);

export default {
    data() {
      return {
        response: ""
      }
    },

    created(){

    },

    mounted() {
       //document.getElementById("signature").innerHTML="<canvas width='694' height='444' style='width: 100%; height: 100%; touch-action: none;'></canvas>"

      //this.$refs.signaturePad.fromDataURL('https://konvajs.org/assets/yoda.jpg')

},

    methods: {
      undoimage() {
      this.$refs.signaturePad.fromDataURL('https://konvajs.org/assets/yoda.jpg')
      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      save() {
      this.$refs.signaturePad.fromDataURL('https://konvajs.org/assets/yoda.jpg')
        this.$refs.signaturePad.mergeImageAndSignature('https://konvajs.org/assets/yoda.jpg');
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        console.log(data);
        alert("Open DevTools see the save data.");
        console.log(isEmpty);
        console.log(data);
      },
      change() {
        this.$refs.signaturePad.options = {
          penColor: "#0000ff"
        };
      },
      resume() {
        this.$refs.signaturePad.options = {
          penColor: "#ff0000"
        };
      },
      eraser() {
        var can = document.getElementsByTagName('canvas');
        alert("OK")

        var ctx = can.getContext('2d');
        alert("OK2")
        ctx.globalCompositeOperation = 'destination-out';
        alert("eraser");

      }

/*
this.$http.post("http://localhost:60742/api/test/2").then(result => {
      alert("resultdata");
          this.response = result.data;
        }, error => {
      alert("errorsend");
          console.error(error);
        });
      */
    }
  }
</script>
